export function getLang() {
    let lang = "fr";
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("lang")) {
        lang = urlParams.get("lang");
    }
    else if (window.location.hash) {
        const hash = window.location.hash;
        const queryStringIndex = hash.indexOf('?');
        if (queryStringIndex !== -1) {
            const hashQuery = hash.substring(queryStringIndex + 1);
            const hashParams = new URLSearchParams(hashQuery);
            if (hashParams.has("lang")) {
                lang = hashParams.get("lang");
            }
        }
    }
    console.log('lang is', lang);
    return lang;
}
